import React from 'react';
import { CartModeProvider, CartModes } from '../../../lib/cartModes';
import { Switch } from 'react-router';
import SentryRoute from '../../../SentryRoute';
import AppPaths from '../../../AppPaths';
import Overview from './Overview/Overview';
import Modify from './Modify/Modify';

export default function WebSubscription() {
  return (
    <CartModeProvider mode={CartModes.manageSubscription}>
      <Switch>
        <SentryRoute exact path={AppPaths.WebSubscription.Root} component={Overview} />
        <SentryRoute exact path={AppPaths.WebSubscription.Modify()} component={Modify} />
      </Switch>
    </CartModeProvider>
  );
}
